export const productName = 'MEGAPACK METEOROLOGÍA LISTO';
export const productShortName = 'Megapack Meteorología Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/5cyGgo6Q48ZyNGR2mGCAbD/MOCKUP.png';

export const checkoutUrl = 'https://megapack-meteorologia-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de Meteorología y Ciencias de la Atmósfera',
  'Tomo 2 — La Atmósfera: Composición, Estructura, Energía y Temperatura',
  'Tomo 3 — Humedad, Nubes, Precipitaciones y Procesos Atmosféricos',
  'Tomo 4 — Presión, Vientos y Circulación Atmosférica',
  'Tomo 5 — Masas de Aire, Frentes y Sistemas Meteorológicos',
  'Tomo 6 — Tormentas, Fenómenos Severos y Riesgos Meteorológicos',
  'Tomo 7 — Observación, Instrumentos y Datos Meteorológicos',
  'Tomo 8 — Pronóstico, Clima y Variabilidad Atmosférica en Latinoamérica',
  'Tomo 9 — Enseñanza de Meteorología: Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos Meteorológicos',
  'Bono 4 — 50 Experimentos y Demostraciones',
  'Bono 5 — 100 Secuencias Didácticas',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de meteorología complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la meteorología',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
